
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabbookinginpune() {



  const cardData =
  {
    keyword: ' Cab Booking in Pune',
    heading: 'AB Ghule Cabs: Cab Booking in Pune',
    headingDescription: 'Looking for reliable, comfortable, and affordable cab services in Pune? AB Ghule Cabs offers convenient and seamless taxi booking options for all your travel needs within Pune. Whether it is for business, leisure, or daily commuting, our well-maintained fleet of vehicles and professional drivers ensure that your journey is safe, stress-free, and on time.',

    top: 'Top Places to Visit in Pune with AB Ghule Cabs',

    topPlaces: [
        {
            title: "Shaniwar Wada",
            description: "A historical fortification in the heart of Pune, Shaniwar Wada is famous for its rich Maratha history. It's a must-visit for history enthusiasts."
        },
        {
            title: "Aga Khan Palace",
            description: "Known for its historical significance, Aga Khan Palace is not only a beautiful architectural landmark but also a place associated with India’s freedom struggle."
        },
        {
            title: "Sinhagad Fort",
            description: "Located on the outskirts of Pune, Sinhagad Fort offers panoramic views of the surrounding valleys and is perfect for history buffs and nature lovers."
        },
        {
            title: "Osho Ashram",
            description: "For those seeking peace and relaxation, Osho Ashram is a world-renowned meditation center located in the city."
        },
        {
            title: "Raja Dinkar Kelkar Museum",
            description: "A fascinating museum showcasing a wide array of artifacts that reflect the rich cultural heritage of India, particularly Maharashtra."
        },
        {
            title: "Pune Okayama Friendship Garden",
            description: "Inspired by the Japanese garden style, this beautifully landscaped garden offers a peaceful retreat for those wanting to enjoy nature."
        },
        {
            title: "Dagdusheth Halwai Ganapati Temple",
            description: "One of the most famous Ganesh temples in Pune, this sacred place draws millions of devotees every year, especially during Ganesh Chaturthi."
        },
        {
            title: "Khadakwasla Dam",
            description: "A popular weekend getaway, Khadakwasla Dam offers a serene environment with boating and picturesque views of the surrounding hills."
        },
        {
            title: "Pune-Okayama Friendship Garden",
            description: "A tranquil Japanese-style garden that offers beautiful pathways, ponds, and a calm atmosphere for a peaceful walk or meditation."
        },
        {
            title: "FC Road (Fashion Street)",
            description: "For those who love shopping, FC Road offers a wide variety of stores, from street markets to branded shops, making it an ideal destination for shopping and dining."
        }
    ],


    services: [
        {
          "name": "One Way Cab Pune",
          description: "AB Ghule Cabs offers reliable one-way cab services from Pune to various destinations. Enjoy a comfortable, affordable, and hassle-free ride with professional drivers and well-maintained vehicles."
        },
        {
          "name": "Best Outstation Cab Service in Pune",
          description: "For the best outstation cab service in Pune, choose AB Ghule Cabs. We offer a range of well-maintained vehicles and experienced drivers for a smooth and safe journey to nearby and distant locations."
        },
        {
          "name": "Outstation Cab Service in Pune",
          description: "AB Ghule Cabs provides affordable and reliable outstation cab services from Pune. Whether you're heading to a nearby city or a distant location, our professional drivers ensure comfort and safety throughout the trip."
        },
        {
          "name": "Taxi in Pune for Outstation",
          description: "Looking for a taxi in Pune for an outstation trip? AB Ghule Cabs offers comfortable and affordable taxi services for all your outstation travel needs, ensuring a smooth journey with well-maintained vehicles."
        },
        {
          "name": "Taxi Service in Pune for Outstation",
          description: "AB Ghule Cabs offers dependable and affordable taxi services for outstation trips from Pune. Our experienced drivers and well-maintained vehicles make sure your outstation journey is smooth and safe."
        },
        {
          "name": "Cab Service in Pune",
          description: "AB Ghule Cabs provides reliable and affordable cab services in Pune for local and outstation trips. Our fleet includes a variety of vehicles to cater to your needs, ensuring a comfortable and safe journey."
        },
        {
          "name": "Taxi in Pune",
          description: "Book a taxi in Pune with AB Ghule Cabs for a smooth and safe ride. We offer convenient, affordable, and reliable taxi services for local and outstation travel, with well-maintained cars and professional drivers."
        },
        {
          "name": "Pune to Shirdi Cab Booking Service",
          description: "AB Ghule Cabs offers convenient and reliable Pune to Shirdi cab booking services. Our well-maintained vehicles and professional drivers ensure a comfortable and safe journey to this spiritual destination."
        },
        {
          "name": "Best Cab Service in Pune",
          description: "For the best cab service in Pune, choose AB Ghule Cabs. We offer reliable, affordable, and comfortable taxis with experienced drivers for both local and outstation trips, ensuring a hassle-free travel experience."
        },
        {
          "name": "Online Cab Booking Pune",
          description: "Book your cab online with AB Ghule Cabs for easy and hassle-free booking. We offer reliable taxi services for local and outstation trips in Pune, with well-maintained vehicles and professional drivers."
        },
        {
          "name": "Pune to Mumbai Cheapest Cab",
          description: "Book the most affordable Pune to Mumbai cab with AB Ghule Cabs. We provide competitive rates and comfortable, reliable rides, ensuring you get the best value for your money on this route."
        },
        {
          "name": "Outstation Taxi Service Pune",
          description: "AB Ghule Cabs offers excellent outstation taxi services from Pune. Whether you’re traveling for business or leisure, we provide comfortable, safe, and affordable cabs for all your long-distance travel needs."
        },
        {
          "name": "Pune Airport to Shirdi Cab",
          description: "Book a cab from Pune Airport to Shirdi with AB Ghule Cabs. Our reliable and affordable taxi services ensure a smooth, comfortable, and timely ride from the airport to Shirdi."
        },
        {
          "name": "Taxi Services in Pune",
          description: "AB Ghule Cabs provides reliable taxi services in Pune for both local and outstation trips. Whether you need a quick ride around the city or a long-distance journey, we ensure a comfortable and safe travel experience."
        },
        {
          "name": "Pune to Shirdi Cab Booking",
          description: "Book your Pune to Shirdi cab with AB Ghule Cabs. Our service offers a comfortable and affordable ride, with well-maintained vehicles and professional drivers for a smooth journey to Shirdi."
        },
        {
          "name": "Cab from Pune to Shirdi",
          description: "Travel comfortably with AB Ghule Cabs, offering reliable and affordable cab services from Pune to Shirdi. Our experienced drivers and well-maintained vehicles ensure a safe and pleasant journey."
        },
        {
          "name": "Pune to Shirdi Cab Price",
          description: "Get the best pricing for your Pune to Shirdi cab trip with AB Ghule Cabs. Our pricing is transparent with no hidden charges, ensuring you enjoy an affordable and comfortable journey."
        },
        {
          "name": "Pune to Bhimashankar Cab Fare",
          description: "Check out the competitive Pune to Bhimashankar cab fare with AB Ghule Cabs. We offer the best rates for a comfortable and safe journey to Bhimashankar with well-maintained vehicles and professional drivers."
        },
        {
          "name": "Pune to Ahmednagar Cab",
          description: "Book your Pune to Ahmednagar cab with AB Ghule Cabs. Our taxi services are affordable, reliable, and comfortable, ensuring a smooth journey to Ahmednagar with experienced drivers and well-maintained vehicles."
        },
        {
          "name": "Pune to Goa Taxi",
          description: "Travel from Pune to Goa comfortably with AB Ghule Cabs. Our taxi services ensure a smooth ride, with experienced drivers and well-maintained vehicles, offering comfort and safety on your way to Goa."
        },
        {
          "name": "Pune to Mumbai Cab Booking",
          description: "Book your Pune to Mumbai cab with AB Ghule Cabs. We offer comfortable, reliable, and affordable taxi services, ensuring a smooth and pleasant journey from Pune to Mumbai."
        },
        {
          "name": "Pune Cab Booking",
          description: "Book your cab in Pune with AB Ghule Cabs for a safe, comfortable, and reliable journey. Whether it’s for a local or outstation trip, we offer a variety of vehicles and professional drivers to meet your needs."
        },
        {
          "name": "Cab Booking in Pune Contact Number",
          description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Cab Booking in Pune. We ensure a smooth and enjoyable ride for all our customers."
        }
      ],

      tableData : [
        ["- One Way Cab Pune", "- Best Outstation cab service in Pune"],
        ["- Outstation cab service in Pune", "- Taxi in pune for outstation"],
        ["- Taxi service in pune for outstation", "- Cab service in Pune"],
        ["- Taxi in Pune", "- Pune to shirdi cab booking service"],
        ["- Best Cab Service in Pune", "- Online cab booking pune"],
        ["- Pune to mumbai cheapest cab", "- Outstation taxi service pune"],
        ["- Pune airport to shirdi cab", "- Taxi services in pune"],
        ["- Pune to shirdi cab booking", "- Cab from pune to shirdi"],
        ["- Pune to shirdi cab price", "- Pune to bhimashankar cab fare"],
        ["- Pune to ahmednagar cab", "- Pune to goa taxi"],
        ["- Pune to mumbai cab booking", "- Pune cab booking"]
      ],
      
      whychoose: [
        {
          WhyChooseheading: "Reliable and Professional Service",
          WhyChoosedescription: "At AB Ghule Cabs, we offer reliable and professional cab booking services in Pune. Whether you need a ride for a local trip, airport transfer, or outstation travel, our drivers are experienced and committed to ensuring you have a safe, comfortable, and timely journey."
        },
        {
          WhyChooseheading: "24/7 Availability",
          WhyChoosedescription: "We understand that travel needs can arise at any time, which is why our cab booking service is available 24/7. Whether you need a ride early in the morning or late at night, we are here to serve you at any time of the day."
        },
        {
          WhyChooseheading: "Affordable Rates",
          WhyChoosedescription: "We provide competitive and transparent pricing, ensuring you get value for your money without any hidden charges. Our affordable rates make us a preferred choice for individuals and groups traveling within Pune and beyond."
        },
        {
          WhyChooseheading: "Wide Range of Vehicles",
          WhyChoosedescription: "We offer a wide variety of vehicles, from budget-friendly sedans to spacious SUVs and luxury cars. Whether you’re traveling solo or with a group, we have the right vehicle to suit your needs and preferences for your trip in Pune."
        },
        {
          WhyChooseheading: "Safe and Comfortable Rides",
          WhyChoosedescription: "Safety is our top priority. Our drivers are experienced, background-checked, and trained to ensure a smooth and secure ride. Our well-maintained vehicles come with modern safety features, ensuring your journey is both comfortable and secure."
        },
        {
          WhyChooseheading: "Easy and Convenient Booking Process",
          WhyChoosedescription: "Booking a cab with AB Ghule Cabs is simple and hassle-free. You can easily book your ride through our user-friendly website, mobile app, or by calling our customer service team for immediate assistance."
        },
        {
          WhyChooseheading: "Customer Satisfaction",
          WhyChoosedescription: "We are committed to customer satisfaction, offering excellent service every time. With numerous positive reviews and loyal customers, we strive to make your travel experience seamless, comfortable, and enjoyable."
        }
      ]
      
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book a cab with AB Ghule Cabs?',
      answer: 'You can book a cab through our website, mobile app, or by calling our customer service team. We offer quick and easy booking options to ensure a smooth ride.',
    },
    {
      id: 'FAQ2',
      question: 'Are your drivers experienced and trustworthy?',
      answer: 'Yes, all of our drivers are highly experienced, professional, and background-checked to ensure you have a safe and pleasant ride.',
    },
    {
      id: 'FAQ3',
      question: 'What types of vehicles are available for booking?',
      answer: 'We offer a range of vehicles, including sedans, SUVs, and luxury cars, so you can choose the vehicle that suits your travel preferences and group size.',
    },
    {
      id: 'FAQ4',
      question: 'How do I pay for my ride?',
      answer: 'You can pay for your ride using various payment options, including cash, credit/debit cards, or online payment through our mobile app, for your convenience.',
    },
    {
      id: 'FAQ5',
      question: 'Are there any additional charges for waiting or detours?',
      answer: 'Additional charges may apply for waiting time or detours, but we ensure full transparency in pricing. Any extra charges will be communicated to you in advance.',
    },
    {
      id: 'FAQ6',
      question: 'Can I cancel or modify my booking?',
      answer: 'Yes, you can modify or cancel your booking easily through our website or app. Our customer service team is also available to assist you with any changes or cancellations.',
    },
    {
      id: 'FAQ7',
      question: 'Do you offer both one-way and round-trip services?',
      answer: 'Yes, we offer both one-way and round-trip services for your convenience, allowing you to choose the option that best suits your travel needs.',
    },
    {
      id: 'FAQ8',
      question: 'Is AB Ghule Cabs available for group travel?',
      answer: 'Yes, we offer spacious vehicles for group travel. Whether you’re traveling with family, friends, or colleagues, we can accommodate your group comfortably.',
    },
    {
      id: 'FAQ9',
      question: 'Why should I choose AB Ghule Cabs over other cab services?',
      answer: 'AB Ghule Cabs stands out for its reliable, professional drivers, affordable rates, a wide range of vehicles, and excellent customer service. We focus on your comfort and satisfaction, ensuring an exceptional travel experience every time.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: "Mr. Harshil Desai",
      feedback: "I booked a cab from AB Ghule Cabs for a trip within Pune, and I was very impressed. The driver was on time, the car was clean and comfortable, and the whole experience was seamless. I will definitely book with them again.",
      rating: 5,
    },
    {
      id: 2,
      name: "Ms. Sunita Verma",
      feedback: "I frequently book cabs for business trips within Pune, and AB Ghule Cabs always delivers excellent service. The booking process is easy, and the drivers are always professional and punctual. I highly recommend them.",
      rating: 5,
    },
  ];
  
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Cab Booking in Pune | Book Cabs for Local & Outstation</title>
  <meta name="description" content="Book a taxi in Pune for local and outstation trips. Offering one-way and round-trip cabs to destinations like Shirdi, Mumbai, Goa, Bhimashankar, and more. Call +91 8624029699 for booking." />
  <meta name="keywords" content="One way cab Pune, Best outstation cab service in Pune, Outstation cab service in Pune, Taxi in Pune for outstation, Taxi service in Pune for outstation, Cab service in Pune, Taxi in Pune, Pune to Shirdi cab booking service, Best cab service in Pune, Online cab booking Pune, Pune to Mumbai cheapest cab, Outstation taxi service Pune, Pune airport to Shirdi cab, Taxi services in Pune, Pune to Shirdi cab booking, Cab from Pune to Shirdi, Pune to Shirdi cab price, Pune to Bhimashankar cab fare, Pune to Ahmednagar cab, Pune to Goa taxi, Pune to Mumbai cab booking, Pune cab booking" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Cab Booking in Pune | Book Cabs for Local & Outstation" />
  <meta property="og:description" content="Book a taxi in Pune for local and outstation trips. Offering one-way and round-trip cabs to destinations like Shirdi, Mumbai, Goa, Bhimashankar, and more. Call +91 8624029699 for booking." />
  <meta property="og:image" content="https://abghulecabs.com/images/cab-booking-pune.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/cab-booking-pune" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "TaxiService",
        "name": "AB Ghule Cabs - Cab Booking in Pune",
        description: "Book a taxi in Pune for local and outstation trips. Offering one-way and round-trip cabs to destinations like Shirdi, Mumbai, Goa, Bhimashankar, and more. Call +91 8624029699 for booking.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411057",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/cab-booking-pune",
        "logo": "https://abghulecabs.com/images/cab-booking-pune.jpg",
        "image": "https://abghulecabs.com/images/cab-booking-pune.jpg",
        "priceRange": "₹1200 - ₹5000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/cab-booking-pune",
          "priceCurrency": "INR",
          "price": "1200",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.7",
          "reviewCount": "240"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Vijay S"
            },
            "datePublished": "2024-09-10",
            "reviewBody": "Booked a cab from Pune to Shirdi. The service was excellent, and the driver was very professional. Will definitely book again!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Nina R"
            },
            "datePublished": "2024-06-20",
            "reviewBody": "Had a great experience booking a cab from Pune to Mumbai. Affordable, reliable, and a comfortable ride. Highly recommended."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune and surrounding areas",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5195",
            "longitude": "73.8551"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/cab-booking-pune"
        },
        "keywords": "One way cab Pune, Best outstation cab service in Pune, Outstation cab service in Pune, Taxi in Pune for outstation, Taxi service in Pune for outstation, Cab service in Pune, Taxi in Pune, Pune to Shirdi cab booking service, Best cab service in Pune, Online cab booking Pune, Pune to Mumbai cheapest cab, Outstation taxi service Pune, Pune airport to Shirdi cab, Taxi services in Pune, Pune to Shirdi cab booking, Cab from Pune to Shirdi, Pune to Shirdi cab price, Pune to Bhimashankar cab fare, Pune to Ahmednagar cab, Pune to Goa taxi, Pune to Mumbai cab booking, Pune cab booking"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/65.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Cabbookinginpune;